<template>
  <div>
    <v-data-table
    dense
    v-resize="onResize"
    id="time__table"
    fixed-header
    :items-per-page="-1" 
    :footer-props="{ itemsPerPageOptions: [-1] }"
    :headers="headers"
    :items="items"
    no-data-text="측정된 자료가 없습니다."
    class="table_content"
    single-select
    hide-default-footer
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    sortBy: {
      type: String,
      default: "date",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    },
    addCommas(num) {
      if (typeof num === "number") {
        return num.toLocaleString();
      }
      return num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
    entityNo(entity){
      if (!entity) return "";
      return entity.replace(/^(\d{3})(\d{5})(\d{3})(\d)$/, "$1 $2 $3 $4");
    },

  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
@import '../../../style/table_mb.scss';
.table_line{
  border-right:1px solid #cfcfcf !important;
  text-align: center;
}
.detail{
  cursor: pointer;
}
::v-deep .v-data-table th {
  background-color: #73a9ff !important;
  text-align: center !important;
  vertical-align: middle !important;
}
.v-table td {
  text-align: center;
  vertical-align: middle;
}
.cow{
  cursor: pointer;
}
</style>
